import { fetchComicChapters } from 'api'
import { useEffect } from 'react'
import { useImmer } from 'use-immer'
import { SchemaComicChapterShow } from 'api/generated'

interface ComicChaptersState {
  currentOptions: {
    comic_id: string | undefined
  }
  list: SchemaComicChapterShow[]
  nextPage: number
  hasMore: boolean
  page_result: {
    current?: number
    pageSize?: number
    total?: number
  }
}

export const useAllComicChapters = (comicId: string | number | undefined, disabled?: boolean) => {
  const apiParams = {
    comic_id: comicId as string | undefined,
  }

  const [state, updateState] = useImmer<ComicChaptersState>(() => ({
    currentOptions: apiParams,
    list: [],
    nextPage: 1,
    hasMore: true,
    page_result: {},
  }))

  useEffect(() => {
    const fetcherController = new AbortController()

    if (disabled) {
      return
    }

    if (!state.hasMore) {
      return
    }

    const data = {
      signal: fetcherController.signal,
      current: state.nextPage,
      pageSize: 100,
      // WARN: force cast string to number because js do not support int64.
      ...(state.currentOptions as unknown as { comic_id: number }),
    }

    fetchComicChapters(data).then((response) => {
      updateState((draft) => {
        draft.list = draft.list.concat(response?.data)
        draft.hasMore = response?.page_result?.total > response?.page_result?.current * response?.page_result?.pageSize
        draft.nextPage = response?.page_result?.current + 1
        draft.page_result = response.page_result
      })
    })

    return () => {
      fetcherController.abort()
    }
  }, [disabled, state.currentOptions, state.hasMore, state.nextPage, updateState])

  return state.list
}
